import React from "react";
import "../style/TradingPrinciples.css";

const Tradingprinciples = () => {
  return (
    <div className="basic-container">
      <header className="basic-header">
        <h1>Trading Principles</h1>
        <p className="basic-date">Colle Learn - August 10, 2023</p>
      </header>
      
      <section className="basic-section basic-hero">
      <div className="basic-img">
          <img src="/images/tpr1.png" alt="Trading Platform" />
          </div>
        <p>As a forex trader, your main goal is to take advantage of market opportunities by buying and selling major currency pairs. But forex trading is no walk in the park. While it’s one of the most popular ways to invest, it also requires plenty of study and research. 

            <br/><br/>To make returns in forex trading, you need a solid plan. That means developing a well-defined strategy so you can keep an eye on price movements. This is where short-term trading tools can be helpful, but only when you have a clear plan in place when trading.

            <br/><br/>That’s why we believe every trader should follow these seven important principles before trading in foreign exchange markets:</p>
      </section>

      <h1>Key Points</h1>
      <div className="key">
        <ul>
            <li>Implement a stop loss for every trade to cap potential losses; a single trade without a stop loss could significantly impact your account and potentially lead to a wipeout.</li>
            <li>Avoid the Martingale system of doubling down to recover losses, as it’s risky and unsustainable; instead, focus on consistent risk management strategies and accept losses as part of trading.</li>
            <li>Prioritise price action over numerous indicators which can clutter your chart and lead to conflicting signals; understanding price movements and market sentiment through candlestick patterns can be more beneficial for making informed trading decisions.</li>
        </ul>
      </div>
            <div id="basic1" className="basic-section">
            <h1>1. Always Use a Stop Loss</h1>
            <p>Sounds simple enough but you’d be surprised how many traders ignore this rule. After all, precautions are placed for a reason so why lose out on more than you need?

                    <br/><br/>Limit your loss for every trade or risk an account wipeout. Sure, you might make it back over time but it takes only one trade to reverse your returns.

                    <br/><br/>Don’t let one trade cause your downfall – protect your account and use a stop loss.</p>
            <h1>2. Don’t Give Into Martingale</h1>
            <p>As a common betting system, martingale doubles the next trade to recover from previous losses. Drop the “double or nothing mindset” because that just won’t work in forex trading. 

                <br/><br/>Returns and losses are part and parcel of trading, and the sooner you accept that the sooner you would be willing to take a more level-headed approach. 

                <br/><br/>Let’s face it, it’s only natural to feel frustrated when trades don’t turn out the way you expect, regardless of how experienced you are. The key difference between a good and an average trader is learning how to take losses in your stride. A good trader knows how to keep their emotions in check and not squander their trades on a risky strategy that could lead to losses.

                <br/><br/>Instead, stick to tried and tested trading principles. Trust the process – fight the urge to double down on losing trades and focus on risk management to get ahead in the long run.</p>

                  <h1>4. No Shortcut to the ‘Holy Grail’</h1>
<p>Save yourself the search for the perfect trading system – it doesn’t exist. There’s no one trading system that will magically give you positive returns with every trade. Far too many novice traders fall into the trap of diving head-first to find a system that works like a charm. But it just doesn’t work like that! 

<br/><br/>Instead, start experimenting with an open mind. Trade and test every single forex strategy you can get your hands on. Becoming an exceptional Forex trader usually takes a lot of trial and error before landing on the right strategy. 

<br/><br/>Eventually, you’ll find certain elements in each strategy that will work for you and others that won’t. Like our different personality traits, strengths, and weaknesses, there is no one-size-fits-all approach. 

<br/><br/>Put yourself on the right path. With proper risk management techniques, build your own strategy through tried and tested elements.</p>

<h1>5. Cap Your Risk at 2%</h1>
<p>Risk management is extremely crucial in any type of trading. No matter how good you think any particular trading setup is, never risk more than 2% of your total account balance on any one trade. 

<br/><br/>Keep your risk management as simple and streamlined as possible, especially if you’re a novice trader. Curb your losses with a consistent 2% risk so you can easily calculate your stop loss and trade size before entering the market.</p>

<h1>6. Play the Positive Risk:Reward Card</h1>
<p>For every trade you take, it should reward you with more money than you risked. 

<br/><br/>This is known as a risk-reward ratio, a trading concept that measures the amount of risk taken for each potential reward. By keeping a positive risk-reward ratio, traders can still make some money back – even if their win rate is below 50%. 

<br/><br/>For example, you consider a trade with a potential profit of $100 and a potential loss of $50. The risk-reward ratio would then be 1:2, meaning for every $1 of risk, there’s a potential reward of $2. 

<br/><br/>If the ratio is below 1:2, the trade isn’t worth the risk. For instance, if you risk $100 on a trade that aims for a profit of $150, then the risk-reward ratio would now be 1:1.5. This means the potential profit will only be $150, which is less than twice the $200 amount you risked. 

<br/><br/>For that reason, we never trade less than a 1:2 risk-reward ratio. Put the odds in your favor! And remember, stay disciplined! Let go of any trade that does not offer a positive risk-reward.</p>

<h1>7. Trust in Your Trading Strategy</h1>
<p>Once you’ve finally formulated a trading strategy that matches your price and personality – trust that it’ll make it. Don’t get distracted by the latest, trendiest trend that pops up. Why scrap all your hard work just to start again? Think rationally before you drop it. 

</p>

<p id="tradp">That’s how the best Forex traders determine what works; by finding their best forex trading strategy and sticking to it. Now, think you can fulfil these essential rules? Test it out yourself! Start trading on the Extrede app and open a FREE demo account with us today.</p>
            <br/><br/><hr/><br/><br/>


            <div id="basic-oslo1"className="oslo-cards">
        <div  className="oslo-card">
          <img
            src="/images/trad.jpg"
            alt="Best intraday trading strategies"
            className="oslo-card-image"
          />
          {/* <p className="oslo-learn"> EXTREDE LEARN • 5 YEARS AGO</p> */}
          <h3 className="oslo-title">Best trading strategies and techniques</h3>
          <p>A trading strategy is a set of rules and guidelines used by traders to make informed decisions about buying, selling, or holding financial instruments such as stocks, currencies, or commodities. It is a systematic approach that helps traders identify and capitalise on trading opportunities based on their analysis of market conditions.</p>
        </div>
        <br/><br/>

        <div className="oslo-card">
          <img
            src="/images/forex.jpg"
            alt="Why Trade Forex: Forex vs. Stocks"
            className="oslo-card-image"
          />
          {/* <p className="oslo-learn"> EXTREDE LEARN • 6 YEARS AGO</p> */}
          <h3 className="oslo-title">Why Trade Forex: Forex vs. Stocks?</h3>
          <p>There are approximately 2,400+ stocks listed on the New York Stock Exchange (NYSE). Another 3,400+ are listed on the NASDAQ</p>
          <p>Which one will you trade? Got the time to stay on top of so many companies? With forex, there are dozens of currencies traded, but the majority of market players trade the seven major pairs.
          Which one will you trade? Got the time to stay on top of so many companies? With forex, there are dozens of currencies traded, but the majority of market players trade the seven major pairs.
          </p>
        </div>
        </div>
            </div>
      

    </div>
  );
};

export default Tradingprinciples;